import { Component, Input } from '@angular/core';
import { hexToRGBA } from '@app/shared/utils';

@Component({
  selector: 'rk-color-chip',
  templateUrl: './color-chip.component.html',
  styleUrls: ['./color-chip.component.scss'],
})
export class ColorChipComponent {
  @Input() live: boolean;
  @Input() break: boolean;
  @Input() ellipsis = true;
  @Input() mini: boolean;
  @Input() name: string;
  @Input() color: string;
  @Input() onFlexed: boolean;

  getSlotStyle(): object {
    return {
      color: this.color,
      background: hexToRGBA(this.color, 0.1),
    };
  }
}
